import React, { useContext, useMemo, useState } from 'react';
import { DemoBankScenario } from '../../../models/demobankScenarios';

export type DemoBankScenarioStateContext = {
  selectedDemoBankScenario: DemoBankScenario | undefined;
  setSelectedDemoBankScenario: (demoBankScenario: DemoBankScenario | undefined) => void;
};

export const DemoBankScenarioContext = React.createContext<DemoBankScenarioStateContext>({
  setSelectedDemoBankScenario: () => null,
  selectedDemoBankScenario: undefined,
});

export type DemoBankScenarioProviderProps = {
  initialDemoBankScenario?: DemoBankScenario;
};

/*
  This context is needed in order to store the selected demobank scenario that can be set by the user
  in the demobank scenario selection screen. The demobank scenario selection takes place
  inside the provider selection process. By selecting a demobank scenario, it will enable our customers
  to test different scenarios, making it easier and faster to create Tink Link integrations.
*/

export const DemoBankScenarioProvider: React.FC<DemoBankScenarioProviderProps> = ({
  children,
  initialDemoBankScenario,
}) => {
  const [selectedDemoBankScenario, setSelectedDemoBankScenario] = useState<
    DemoBankScenario | undefined
  >(initialDemoBankScenario);

  const demobankScenarioContext = useMemo(
    () => ({ selectedDemoBankScenario, setSelectedDemoBankScenario }),
    [selectedDemoBankScenario, setSelectedDemoBankScenario]
  );

  return (
    <DemoBankScenarioContext.Provider value={demobankScenarioContext}>
      {children}
    </DemoBankScenarioContext.Provider>
  );
};

export const useDemoBankScenarioProvider = () => useContext(DemoBankScenarioContext);
